import img1 from "../../../assets/Vector1.png";
import img2 from "../../../assets/vector2.png";
// import brand1 from "../../../assets/icons/border.png";
// import brand2 from "../../../assets/icons/penta.png";  
// import brand3 from "../../../assets/icons/chain.png";
// import brand4 from "../../../assets/icons/cloud.png";
// import brand5 from "../../../assets/icons/cactus.png";

import { Footer } from "../../Footer";
import { FAQ } from "../../FAQ";
import { HeroSection } from "./HeroSection";
import { FeatureSection } from "./FeatureSection";
import bgImg from "../../../assets/vector-bg.svg";
import { TestimonialSwiper } from "../../TestimonialSwiper";
import { PowerfulEditing } from "./PowerfulEditing";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../AuthProvider';
import { Chat } from '../../Chat';
import { EmailCapture } from '../../EmailCapture';

export const Home = () => {

    const { currentUser } = useAuth();
    const navigate = useNavigate();

    const handleGetStarted = async () => {
        if (currentUser) {
          // If already logged in, go directly to dashboard
          navigate("/recentactivities");
        } else {
          // Otherwise, redirect to login/signup
          navigate("/login");
        }
      };

  return (
    <>
      <div className="w-full overflow-hidden">
        {/* Navbar */}
        {/* <Nav /> */}

        {/* Hero Section */}
        <HeroSection />


        {/* trusted brand  */}

        {/* <section>
          <div className="max-w-8xl mx-auto py-[40px] flex items-center justify-center flex-col">
            <h3 className="text-[24px] text-[#121926] font-medium">Trusted by thousands of brands</h3>
            <div className="max-w-8xl brands flex items-center justify-between gap-12">
              <img src={brand1} alt="brand1" />
               <img src={brand2} alt="brand2" />
               <img src={brand3} alt="brand3" />
              <img src={brand4} alt="brand4" />
              <img src={brand5} alt="brand5" />

            </div>
          </div>
        </section> */}

        {/* Feature Details Section */}
        <FeatureSection />

        {/* Stats Banner */}
        <div className="px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 2xl:px-[120px] mb-12 sm:mb-16 md:mb-20 lg:mb-[80px]">
          <div
            className="bg-black w-full rounded-2xl sm:rounded-3xl lg:rounded-4xl h-auto min-h-[200px] sm:min-h-[220px] md:min-h-[240px] lg:h-[260px] p-6 sm:p-8 md:p-12 lg:p-16 xl:p-[80px] bg-center bg-cover"
            style={{ backgroundImage: `url(${bgImg})` }}
          >

            <div className="grid grid-cols-2 lg:flex lg:items-center lg:justify-between text-white gap-6 sm:gap-8 lg:gap-4">
              <div className="flex flex-col items-center text-center">
                <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-bold">
                  20K+
                </h3>
                <span className="text-xs sm:text-sm md:text-base lg:text-[20px] text-[#CDD5DF] mt-1">
                  Images Processed
                </span>
              </div>
              <div className="flex flex-col items-center text-center">
                <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-bold">
                  5K+
                </h3>
                <span className="text-xs sm:text-sm md:text-base lg:text-[20px] text-[#CDD5DF] mt-1">
                  Active Users
                </span>
              </div>
              <div className="flex flex-col items-center text-center">
                <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-bold">
                  8K+
                </h3>
                <span className="text-xs sm:text-sm md:text-base lg:text-[20px] text-[#CDD5DF] mt-1">

                  Designers Joined
                </span>
              </div>
              <div className="flex flex-col items-center text-center">
                <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-bold">
                  98%
                </h3>
                <span className="text-xs sm:text-sm md:text-base lg:text-[20px] text-[#CDD5DF] mt-1">
                  Accuracy Rate
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* PowerfulEditing */}
        {/*<PowerfulEditing /> */}

        {/* Testimonials Section */}
        <TestimonialSwiper />
        {/* CTA Section */}
        <section className="py-12 sm:py-16 bg-white px-4 sm:px-6 md:px-8 lg:px-16 mt-0">
          <div className="max-w-7xl xl:max-w-8xl mx-auto">
            <div
              className="relative rounded-2xl sm:rounded-3xl overflow-hidden bg-black min-h-[300px] sm:min-h-[350px] md:min-h-[400px] lg:h-[400px]"
            >
              <div className="relative px-4 sm:px-6 md:px-8 lg:px-12 xl:px-32 py-8 sm:py-12 md:py-16 h-full flex items-center">
                {/* Background Images */}
                <img
                  className="hidden sm:block object-cover absolute top-2 left-2 w-16 sm:w-20 md:w-24 lg:w-auto h-auto opacity-50"
                  src={img1}
                  alt=""
                />
                <img
                  className="hidden sm:block object-cover absolute bottom-4 right-4 sm:right-6 w-16 sm:w-20 md:w-24 lg:w-auto h-auto opacity-50"
                  src={img2}
                  alt=""
                />

                <div className="text-center flex items-center justify-center flex-col w-full z-10 relative">
                  <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[56px] font-bold text-white leading-tight sm:leading-tight md:leading-tight lg:leading-[4vw] font-[Playfair-Display] mb-4 sm:mb-6">
                    Transform your garment photos into stunning, on-model imagery in seconds
                  </h2>
                  <p className="text-sm sm:text-base md:text-lg lg:text-[20px] text-gray-300 w-full sm:w-[90%] md:w-[80%] lg:w-[65%] xl:w-[55%] mb-6 sm:mb-8">
                    Join thousands using Gomens to save time and money on traditional photoshoots.
                  </p>
                  <div>
                    <a
                      onClick={handleGetStarted}
                      className="cursor-pointer inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-medium rounded-lg shadow-lg bg-white text-black hover:bg-gray-100 transition-all duration-300"
                    >
                      Generate Your First Model (Free)
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Email Capture Section — hidden until backend is ready */}
        {/* <EmailCapture /> */}

        {/* FAQ Section */}
        <section className="py-12 sm:py-16 bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center flex-col">
            <p className="text-purple-500 text-sm sm:text-base lg:text-[18px] mb-2">
              Still Curious?
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[48px] font-[Playfair-Display] font-bold text-center mb-4 sm:mb-6 leading-tight">
              Frequently Asked Questions
            </h2>
            <p className="text-sm sm:text-base lg:text-[18px] mb-8 sm:mb-12 lg:mb-[60px] text-center max-w-2xl">
              Quick answers about how our tools work, what files we support, and how to get started.
            </p>
            <FAQ />
          </div>
        </section>

        {/* Footer */}
        <Footer />
        
        {/* Chat Widget */}
        <Chat />
      </div>
    </>
  );
};